module.exports = __webpack_public_path__ + "static/media/sidebar.b46d244b.svg";